import {ActionContext} from 'vuex';
import {api} from '@/api';
import {
	GetPartnersInfoByNoRequest,
	PartnersInfoByNo,
	PutPartnersInfoRequest
} from 'supporter'

interface State {
	popupData: string;
	partnersInfoByNo: PartnersInfoByNo;
}
export default {
  namespaced: true,
  state: {
    popupData: '',
	  partnersInfoByNo: {
		  partnerStatus: '',
		  manager: {},
		  business: {},
		  permittedIpAddress: '',
		  partnerName: '',
		  internationalCode: {},
		  privacyManager: {},
		  sellerTaxationType: '',
		  companyName: '',
		  settlementManager: {},
		  office: [],
		  supportsInternationalShipping: false,
		  partnerNo: '',
		  sampleUrl: '',
		  faxNo: '',
		  masterAdmin: {},
		  countryCode: '',
		  tradeBank: {},
		  representative: {},
			csManager: {},
			dependencyYn: false,
	  }
  },
  getters: {
    popupData(state: State): string {
      return state.popupData;
    },
	  partnersInfoByNo(state: State): PartnersInfoByNo {
    	return state.partnersInfoByNo
	  }
  },
  mutations: {
    SET_POPUP(state: State, popupData: string): void {
      state.popupData = popupData;
    },
	  SET_PARTNER_INFO_BY_NO(state: State, partnersInfoByNo: PartnersInfoByNo): void {
    	state.partnersInfoByNo = partnersInfoByNo
	  }
  },
  actions: {
    dataUpdate({commit}: any, popupData: string): void {
      commit('SET_POPUP', popupData);
    },
	  async fetchPartnersInfoByNo({commit}: ActionContext<State, any>, payload: GetPartnersInfoByNoRequest): Promise<void> {
    	const {data} = await api.getPartnersInfoByNo(payload)
	    commit('SET_PARTNER_INFO_BY_NO', data)
    },
	  async putPartnersInfoByNo(_, payload: PutPartnersInfoRequest) {
      // api 상 오류가 발생하면 pathParams 항목이 삭제되어 그 때 부터는 파트너 수정 api 가 정상적으로 호출되지 않는 이슈가 발생함
      // 일단.. 어디서 삭제하고 있는지 찾기가 어려워서 참조를 끊어내는 방식으로 수정함
    	const res = await api.putPartnersInfoByNo({...payload});
			// response 값이 없음. 레거시에서는 수정 정보 넘긴 후 바로 파트너 조회 페이지 초기화 상태로 리다이렉트 됨
	  }
  }
};

